import React, { useMemo } from 'react';
import { QueryClientProvider, QueryClient, DefaultOptions } from 'react-query';

interface Props {
  options?: DefaultOptions;
  children: React.ReactNode;
}

export const POSQueryClientProvider: React.FC<Props> = ({
  children,
  options,
}) => {
  const client = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000,
            retry: 3,
            ...options?.queries,
          },
          mutations: options?.mutations,
        },
      }),
    [options]
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
};
